const formatTime = (secs: number) => {
const minutes = Math.floor(secs / 60)
const seconds = secs % 60

  return `${String(minutes).padStart(2,'0')}:${String(seconds).padStart(2,'0')}`;
};


export default formatTime